/* eslint-disable @typescript-eslint/no-explicit-any */
import axios, { AxiosResponse } from 'axios'
import { sortBy } from 'lodash'
import { unique } from 'src/refactor/helpers/array'
import {
  PCP_SERVICE_LINE,
  PCP_SERVICE_LINE_NAMES,
} from 'src/refactor/helpers/constants'
import { GetFacilities } from './types'

export const isResultFulfiled = <T>(
  res: PromiseSettledResult<T>
): res is PromiseFulfilledResult<T> =>
  (res as PromiseFulfilledResult<T>).status === 'fulfilled'

export const flatGetFacilitiesResults = (
  results: AxiosResponse<GetFacilities>[]
) => {
  const getFacilitiesResults = results
    .map(result => result.data)
    .filter(result => !!result)

  const result: GetFacilities = {
    ...getFacilitiesResults[0],
    count: {
      total: 0,
    },
    data: [],
    specialtyFilters: [],
  }

  getFacilitiesResults.forEach(getFacilitityResult => {
    result.specialtyFilters = [
      ...result.specialtyFilters,
      ...getFacilitityResult.specialtyFilters,
    ]
    result.networks = [...result.networks, ...getFacilitityResult.networks]
    result.count.total += getFacilitityResult.count.total
    result.data = [...result.data, ...getFacilitityResult.data]
  })

  result.specialtyFilters = sortBy(
    unique(result.specialtyFilters, ['name', 'code']),
    ['name']
  )

  result.data = sortBy(result.data, ({ distance }) => Number(distance))

  return result
}

export const isSuccessResponse = <T = any>(
  response: AxiosResponse<T> | AxiosResponse<any>
): response is AxiosResponse<T> => {
  return (response as AxiosResponse<T>).status.toString().startsWith('20')
}

export async function parseAxiosErrors<
  F extends () => Promise<AxiosResponse<any>>,
  T = any
>(func: F): Promise<ReturnType<F> | AxiosResponse<any>> {
  try {
    const response = await func()

    return response
  } catch (e: any) {
    if (axios.isAxiosError(e)) {
      console.error(e)

      return e.response as AxiosResponse<T>
    }

    throw new Error(e)
  }
}

export const getIsPcpValue = (serviceLines?: string) =>
  PCP_SERVICE_LINE_NAMES.includes(serviceLines ?? '')

export const getPractitionersServiceLinesValue = (serviceLines?: string) =>
  PCP_SERVICE_LINE === serviceLines ? undefined : serviceLines
